"use strict";

exports.__esModule = true;
exports.ENABLE_UI_PREFERENCES_SYNC = exports.ENABLE_UI_PREFERENCES = exports.ENABLE_SCHEDULE_TRIGGERS = exports.ENABLE_RULES_DSL_DOWNLOAD = exports.ENABLE_MODERN_UI_REPORTS = exports.ENABLE_MODERN_UI_OVERRIDE = exports.ENABLE_MODERN_UI_OPERATOR_PANEL = exports.ENABLE_MODERN_UI_MAINTENANCE_MANAGER = exports.ENABLE_MODERN_UI_KNOWLEDGE_BASE = exports.ENABLE_MODERN_UI_DEVICE_DATA = exports.ENABLE_MODERN_UI_DASHBOARD = exports.ENABLE_MODERN_UI = exports.ENABLE_HISTORICAL_PART_COUNT_SHIFT_EDIT = exports.ENABLE_HISTORICAL_PART_COUNT_BY_SHIFT = exports.ENABLE_DATA_ITEM_SAVE = exports.ENABLE_DATA_ITEM_EDIT = exports.ENABLE_DATA_ITEM_CHART_V2 = exports.ENABLE_ALERTS_CREATION = exports.ENABLE_AI_AUTHORING = exports.ENABLE_ADVANCED_METRIC_CHART = void 0;
/*
    Allows to edit data items for widgets: MTC Value, MTC Data Table and Data Item Chart (VLS-608)
*/
var ENABLE_DATA_ITEM_EDIT = exports.ENABLE_DATA_ITEM_EDIT = "ENABLE_DATA_ITEM_EDIT";

/*
    Allows to save changed data items for widgets: MTC Value, MTC Data Table and Data Item Chart (VLS-675)
*/
var ENABLE_DATA_ITEM_SAVE = exports.ENABLE_DATA_ITEM_SAVE = "ENABLE_DATA_ITEM_SAVE";

/*
    Allows to show shift button in historical part count (VLS-705)
*/
var ENABLE_HISTORICAL_PART_COUNT_BY_SHIFT = exports.ENABLE_HISTORICAL_PART_COUNT_BY_SHIFT = "ENABLE_HISTORICAL_PART_COUNT_BY_SHIFT";

/*
    Allows to edit historical part count by shift
*/
var ENABLE_HISTORICAL_PART_COUNT_SHIFT_EDIT = exports.ENABLE_HISTORICAL_PART_COUNT_SHIFT_EDIT = "ENABLE_HISTORICAL_PART_COUNT_SHIFT_EDIT";

/*
    Allows to show download button on rules dsl screen (VLS-756)
*/
var ENABLE_RULES_DSL_DOWNLOAD = exports.ENABLE_RULES_DSL_DOWNLOAD = "ENABLE_RULES_DSL_DOWNLOAD";

/*
    Allows to show data item data from alerts page and create alert from there (VLS-948)
*/
var ENABLE_ALERTS_CREATION = exports.ENABLE_ALERTS_CREATION = "ENABLE_ALERTS_CREATION";

/*
    Allows to configure schedule triggers for knowledge base
*/
var ENABLE_SCHEDULE_TRIGGERS = exports.ENABLE_SCHEDULE_TRIGGERS = "ENABLE_SCHEDULE_TRIGGERS";

/*
    Allows to show Data Item Chart V2 widget in report, dashboard and operator panel
*/
var ENABLE_DATA_ITEM_CHART_V2 = exports.ENABLE_DATA_ITEM_CHART_V2 = "ENABLE_DATA_ITEM_CHART_V2";
/*
    Allows to show Advanced Metric Chart widget in report, dashboard and operator panel
*/
var ENABLE_ADVANCED_METRIC_CHART = exports.ENABLE_ADVANCED_METRIC_CHART = "ENABLE_ADVANCED_METRIC_CHART";

/*
    The modern UI (the ui-charts-update refresh), shipped dark behind flags.
    ENABLE_MODERN_UI alone switches the global chrome: sidebar, fonts, tokens.
    Each screen then opts in with its own flag; a screen flag without the
    master does nothing. ENABLE_MODERN_UI_OVERRIDE lets a tester pin one
    browser with ?ui=modern or ?ui=legacy. See docs/FeatureFlags.md.
    Remove all of these at the promote-or-drop decision (8 weeks after the
    first production enablement).
*/
var ENABLE_MODERN_UI = exports.ENABLE_MODERN_UI = "ENABLE_MODERN_UI";
var ENABLE_MODERN_UI_DASHBOARD = exports.ENABLE_MODERN_UI_DASHBOARD = "ENABLE_MODERN_UI_DASHBOARD";
var ENABLE_MODERN_UI_REPORTS = exports.ENABLE_MODERN_UI_REPORTS = "ENABLE_MODERN_UI_REPORTS";
var ENABLE_MODERN_UI_OPERATOR_PANEL = exports.ENABLE_MODERN_UI_OPERATOR_PANEL = "ENABLE_MODERN_UI_OPERATOR_PANEL";
var ENABLE_MODERN_UI_KNOWLEDGE_BASE = exports.ENABLE_MODERN_UI_KNOWLEDGE_BASE = "ENABLE_MODERN_UI_KNOWLEDGE_BASE";
var ENABLE_MODERN_UI_DEVICE_DATA = exports.ENABLE_MODERN_UI_DEVICE_DATA = "ENABLE_MODERN_UI_DEVICE_DATA";
var ENABLE_MODERN_UI_MAINTENANCE_MANAGER = exports.ENABLE_MODERN_UI_MAINTENANCE_MANAGER = "ENABLE_MODERN_UI_MAINTENANCE_MANAGER";
var ENABLE_MODERN_UI_OVERRIDE = exports.ENABLE_MODERN_UI_OVERRIDE = "ENABLE_MODERN_UI_OVERRIDE";

/*
    Lets each signed-in user choose the modern or the legacy interface: the
    navbar switch, Settings -> Interface and (with ENABLE_MODERN_UI_OVERRIDE)
    a ?ui= link. Without it none of those exist and a saved choice is
    ignored, so the environment's flags alone decide what renders: a
    deployment with no modern-UI flags at all (production) shows the legacy
    UI with no way for anyone to turn the modern one on. This is the gate
    that keeps the modern UI off an environment; see docs/FeatureFlags.md.
*/
var ENABLE_UI_PREFERENCES = exports.ENABLE_UI_PREFERENCES = "ENABLE_UI_PREFERENCES";

/*
    Saves each user's interface preferences (modern / legacy UI, per screen)
    to svc-licensing and loads them back on sign-in; needs
    ENABLE_UI_PREFERENCES. Off until the service exposes the user-preferences
    resource; until then the choices live in the browser only. See
    notes/LICENSING_API_CONTRACT_FOR_UI.md §8.
*/
var ENABLE_UI_PREFERENCES_SYNC = exports.ENABLE_UI_PREFERENCES_SYNC = "ENABLE_UI_PREFERENCES_SYNC";

/*
    "Create with AI" and "Edit with AI" for dashboards and reports, backed by
    svc-ai (notes/frontend-api-guide.md). Generated documents are kept in the
    browser (the collections' local store) until svc-ui-config takes them.
    `aiURL` in env.json points at the AI service; without it the API host is
    used.
*/
var ENABLE_AI_AUTHORING = exports.ENABLE_AI_AUTHORING = "ENABLE_AI_AUTHORING";